import { StateSchema } from 'app/providers/StoreProvider';

export const getUserData = (state: StateSchema) => state.user.user;
export const getPlotOptions = (state: StateSchema) => state.user.plotOptions;
export const getCart = (state: StateSchema) => state.user.cart;
export const getGameData = (state: StateSchema) => state.user.gameData;
export const getRestartState = (state: StateSchema) => state.user.isDropped;
export const getCurrentInCart = (state: StateSchema) => state.user.currentCart;
